
export const AMBER = '#FAAD14';
export const GREY = '#BFBFBF';
export const GREEN = '#52C41A';
export const RED = '#F5222D';
export const BLUE = '#1890FF';
